<template>

      <div class="wrapper wrapper-content">
        <div class="container-fluid">


<div class="">

  <div class="row">
    <div class="col-lg-12">
      <div class="tabs-container">
        <ul class="nav nav-tabs">
            <li :class="{ active: todayActive }">
              <router-link :to="{name: 'reqcredit'}"  @click.native="toggleActive" class="no-margins text-center"><i class="fa fa-list-ol"></i> รายการ แจ้ง ฝาก-ถอน</router-link>
            </li>
            <li :class="{ active: historyActive }" >
              <router-link :to="{name: 'reqcredit'}"  @click.native="toggleActive" class="no-margins text-center text-nowrap"><i class="fa fa-history"></i> รายการ แจ้ง ฝาก-ถอนย้อนหลัง</router-link>
            </li>
        </ul>
        <div class="tab-pane active">
          <div class="panel-body p-xs">
              <div class="row m-b-xs">
                <div class="col-xs-12 col-md-6 col-sm-3 m-b-xs">

                  <!-- <form class="form-horizontal form-request" data-reload-esc="true">
                    <div class="input-group">
                      <input type="text" name="search" value="" placeholder="Search" class="input-sm form-control">
                      <span class="input-group-btn">
                        <button type="submit" class="btn btn-sm btn-primary">ค้นหา</button>
                      </span>
                    </div>
                    <input type="hidden" name="show" id="show">
                  </form> -->

                </div>
                <div class="col-xs-12 col-md-6 col-sm-9 text-right" v-if="todayActive">
                  <router-link :to="{name: 'deposit'}" class="btn btn-xs-block btn-info"><i class="fa fa-plus-circle"></i> แจ้งเติมเครดิต</router-link>
                  <router-link :to="{name: 'withdraw'}" class="btn btn-xs-block btn-danger"><i class="fa fa-minus-circle"></i> แจ้งถอนเครดิต</router-link>
                </div>
              </div> <!-- /.row -->

              <div class="table-responsive">

                <data-tables :data="jobtaskTableData" :pagination-props="{ pageSizes: [10, 25, 50, 100] }" :table-props="tableProps">

                  <el-table-column prop="status" label="สถานะ" width="150">
                      <template slot-scope="scope">
                        <div class="text-info" v-if="scope.row.status_id == '1'"> {{scope.row.status}} </div>
                        <div class="text-success" v-else-if="scope.row.status_id == '2'"> {{scope.row.status}} </div>
                        <div class="text-danger" v-else> {{scope.row.status}} </div>
                      </template>
                  </el-table-column>
                  <el-table-column prop="cancel_request" label="ยกเลิก/แก้ไข" width="150">
                    <template slot-scope="scope">
                        <button type="button" class="btn btn-xs btn-danger btn-refund" @click.once="cancelRequest(scope.row)" v-if="scope.row.status_id == 1 && scope.row.action == 'debit'"><i class="fa fa-times" ></i> ยกเลิก</button>
                        <button type="button" class="btn btn-xs btn-info" @click="editRequest(scope.row)" v-if="scope.row.status_id == 3 && scope.row.action == 'debit' && isValidEditTime(scope.row.updated_at)"><i class="fa fa-times" ></i> แก้ไขเวลาแจ้งฝาก</button>
                    </template>
                  </el-table-column>

                  <el-table-column prop="action" label="ประเภท" width="200">
                      <template slot-scope="scope">
                        <div class="text-info" v-if="scope.row.action == 'debit'"> แจ้งฝาก </div>
                        <div class="text-warning" v-else> แจ้งถอน </div>
                      </template>
                  </el-table-column>
                  <el-table-column type="transaction_date" label="วันที่/เวลาฝาก" width="200">
                      <template slot-scope="scope">
                        <div v-if="scope.row.action == 'debit'"> {{ formatTransactionDate(scope.row.transaction_date) }} </div>
                        <div v-else></div>
                        
                      </template>
                  </el-table-column>
                  <el-table-column prop="amount" label="จำนวน" width="150">
                      <template slot-scope="scope">
                        {{ formatMoney(scope.row.amount.toFixed(2)) }}
                      </template>
                  </el-table-column>

                  <el-table-column prop="created_at" label="วันที่" width="200" >
                      <template slot-scope="scope">
                        {{ formatDate(scope.row.created_at) }}
                      </template>
                  </el-table-column>

                </data-tables>

              </div> <!-- /.table-responsive -->

              <span class="text-primary-new">อัพเดตล่าสุด {{ lastUpdate }}</span>
              <hr>
              <small>หากท่านพบปัญหาในการแจ้งฝาก/ถอนเงิน กรุณาติดต่อแอดมินผ่าน <a :href="line_contact" target="_blank" class="text-success">ไลน์ </a> </small>

              
          </div>
        </div>
      </div> <!-- /.col-lg-12 -->
    </div> <!-- /.row -->
  </div> <!-- /.row -->


            </div>


        </div>
      </div> <!-- page-wrapper -->
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'

export default {
    name: 'Reqcredit',
    data () {
        return {
            lastUpdate: moment().format('DD/MM/YYYY HH:mm:ss'),
            jobtaskTableData: [],
            jobtaskTableTotal: 0,
            tableProps: {
                border: true,
                stripe: true,
                defaultSort: {
                    prop: 'created_at',
                    order: 'descending'
                },
            },
            todayActive: true,
            historyActive: false,
            fullname: '',
            line_contact: '',
            line_name: '',
        }
    },
    computed: {
        ...mapState({
            user: state => state.user.user,
            lineContact: state => state.information.lineContact,
        })
    },
    mounted () {
    },
    created () {
        this.loadJobtaskTable()

        if (this.lineContact.link || this.lineContact.name){
            this.line_contact = this.lineContact.link
            this.line_name = this.lineContact.name
        }
        else {
            this.loadLineContact()
        }
    },
    methods: {
        async loadJobtaskTable () {

            let jobtaskQuery = {
                order: 'desc',
            }

            if ( this.todayActive ) {
                jobtaskQuery.type = 'today'
            }
            else {
                jobtaskQuery.type = 'history'
            }

            try {
                const response = await this.$store.dispatch('jobtask/getAllJobtask', jobtaskQuery)
                //console.log('async loadJobtaskTable', response)
                this.jobtaskTableData = response.result

                this.fullname = this.user.username

                this.getNow()

            } catch (error) {
                console.log('error', error)
                this.$toasted.error('There was an error connecting to the server.')
            }
        },

        async cancelRequest (request_data) {

            // cannot cancel if deposit
            if ( request_data.action == 'credit' ) {
                return
            }
            let r = confirm('ยืนยันการยกเลิกแจ้งฝาก?')
            if (r == true) {

                // get jobtask status again for ensure that user cannot cancelled after admin has been approved
                try {
                    const response = await this.$store.dispatch('jobtask/getJobtask', request_data.id)
                    //console.log('async loadJobtaskTable', response)

                    if ( response.status_id == 1 ) {

                        try {
                            await this.$store.dispatch('jobtask/cancelJobtask', response)
                            this.$toasted.success('ยกเลิกการแจ้งฝาก แล้ว.')
                        } catch (error) {
                            this.$toasted.error('Your Request couldn\'t be canceled. There was an error connecting to the server.')
                        }

                    }
                    else {
                        this.$toasted.error('ไม่สามารถยกเลิกรายการแจ้งฝากได้ เนื่องจากรายการมีการเปลี่ยนแปลงสเตตัส')
                    }
                    this.$router.go(0)


                } catch (error) {
                    console.log('error', error)
                    this.$toasted.error('There was an error connecting to the server.')
                } finally {
                    this.$root.$emit('navbar')
                }

            }

        },

        async editRequest (request_data) {
            this.$router.push({name: 'deposit', query: {taskId: request_data.id}})
        },

        isValidEditTime(cancel_time) {
            let end_edit_time = moment(cancel_time).add(180, 'minutes')
            if ( moment().isSameOrBefore(end_edit_time) ) {
                return 1
            }
            return 
        },

        formatMoney(num) {
            if (num) {
                return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            }
            return num
        },

        formatDate (value) {
            if (value) {
                return moment(value).format('DD/MM/YYYY HH:mm:ss')
            }
        },

        formatTransactionDate (value) {
            if (value) {
                return moment(value).format('DD/MM/YYYY HH:mm')
            }
        },

        getNow () {
            this.lastUpdate = moment().format('DD/MM/YYYY HH:mm:ss')
        },

        toggleActive () {
            //console.log('toggleActive', this.todayActive, this.historyActive)
            this.todayActive = !this.todayActive
            this.historyActive = !this.historyActive

            this.loadJobtaskTable()
        },

        async loadLineContact () {
            try {
                const response = await this.$store.dispatch('information/getLineContact')
                this.line_contact = response.link
                this.line_name = response.name

            } catch (error) {
                console.log('error', error)
            }
        },
    },
}
</script>

<style lang="sass" scoped>
</style>
